import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/app/home/components/ArticlesCardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/app/home/components/blogCard/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/app/home/components/BlogSideBar/BlogSideBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/app/home/components/surgerySection/SurgeryContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/components/DynamicText.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/homePage/BlogSideBar/ellipsis.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/homePage/FeatureImage.webp");
